import { render, staticRenderFns } from "./WhiteButton.vue?vue&type=template&id=80fecfe8&scoped=true&"
import script from "./WhiteButton.vue?vue&type=script&lang=js&"
export * from "./WhiteButton.vue?vue&type=script&lang=js&"
import style0 from "./WhiteButton.vue?vue&type=style&index=0&id=80fecfe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fecfe8",
  null
  
)

export default component.exports